import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "weather-sw",
  "use": "weather-sw-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-down-left\" id=\"weather-sw\"><line x1=\"17\" y1=\"7\" x2=\"7\" y2=\"17\" /><polyline points=\"17 17 7 17 7 7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol